module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADPSURBVHgBtZLBDcIwDEVNxRkWoAtQ7qgTdAHoBEzCnRGYACZgAegdxABtBoAJ+F/1wY3SplLFl56aJrbj2BaZqJlZ78ERLCI+NTiBi92kkwMriSsFD/WRRDeX4A6aEQFqJbUBQrcU5p/rzLPpZPABT3O4BhsvoH1eo1l0VASyyBS/NqV4xabx1TOiYwXegQDsQM7FXPr1AluJKJGJsgFiAzQoOnM4xgwSa+MkcCG7UOkhOUtb3JvZc2pTxm7JNSN24DBk2NeFr3530nbjf/oBYL4iHb3OBEQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/englishVoice/icon_check_qa.png
// module id = 7IfV
// module chunks = 4